import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Container,
  Paper,
  TableContainer,
  TablePagination,
  CircularProgress,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { getHeader } from "../../utils/utils2";
import { toastError } from "../../utils/util";

function ServiceCodesList() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // MUI Pagination states (MUI page is 0-indexed)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchServiceCodes = async () => {
    setLoading(true);
    try {
      // Backend expects 1-indexed page
      const response = await axios.get(
        `${API_ENDPOINT}/admin/service-codes?page=${
          page + 1
        }&limit=${rowsPerPage}`,
        getHeader()
      );
      setData(response.data.data);
      setTotalCount(response.data.total);
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data whenever page or rowsPerPage changes
  useEffect(() => {
    fetchServiceCodes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when changing row count
  };

  return (
    <Box>
      <Container>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
          mt={3}
        >
          <Typography variant="h5">Service Codes</Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            // Adjust this route path to match your React Router setup
            onClick={() => navigate("/add-service-codes")}
          >
            Add Service Codes
          </Button>
        </Stack>

        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer>
            <Table aria-label="service codes table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Exhibitor ID
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Company Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Hall Number</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Stand Number
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : data.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                      No Service Codes Found.
                    </TableCell>
                  </TableRow>
                ) : (
                  data.map((row) => (
                    <TableRow key={row._id}>
                      <TableCell>{row.exhibitorId}</TableCell>
                      <TableCell>{row.companyName}</TableCell>
                      <TableCell>{row.hallNumber}</TableCell>
                      <TableCell>{row.standNumber}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Container>
    </Box>
  );
}

export default ServiceCodesList;
